import { DateTime } from 'luxon'

export const buildRequestBody = (payload) => {
  const filters = []
  if (payload.hasFilters) {
    filters.push({
      key: payload.parent,
      operator: '=',
      value: payload.id,
    })
  }
  if (filters.length > 0) payload.body.filter = filters
  return payload.body
}

export const dateTimeSquasher = (payload) => {
  // until some business level decisions are made, all TZ are GMT
  const returnedData = payload
  // force two-line datetimes and abbreviate tzs
    if (returnedData.createdAt) {
      let created = DateTime.fromISO(returnedData.createdAt, { zone: 'gmt' }).toFormat('ccc, dd LLL yyyy\nhh:mm:ss' +
        ' ZZZZ')
      // feeding Luxon "gmt" still will not render the desired "GMT" string in the result. Documentation is sparse
      // on this, so just using a replace on the result as a stopgap
      created = created.replace('UTC', 'GMT')
      returnedData.createdAt = created
    }
  return returnedData
}
